export interface AlertProps {
  type: 'success' | 'info' | 'warning' | 'error';
  message?: string;
  title?: string;
}

const getClasses = (type: 'success' | 'info' | 'warning' | 'error'): string => {
  switch (type) {
    case 'success':
      return 'bg-success-50 rounded text-success-400 pr-2 py-1 text-xs';
    case 'error':
      return 'bg-error-75 rounded text-error-300 pr-2 py-1 text-xs';
    case 'warning':
      return 'bg-primary-50 rounded text-primary-400 pr-2 py-1 text-xs';
    case 'info':
      return 'bg-secondary-50 rounded text-secondary-400 pr-2 py-1 text-xs';
    default:
      throw new Error(`Unable to implement alert with type: ${type}`);
  }
};

const getIcons = (type: 'success' | 'info' | 'warning' | 'error'): string => {
  switch (type) {
    case 'success':
      return 'ra-icons-generic-checked';
    case 'error':
      return 'ra-icons-generic-error';
    case 'warning':
      return 'ra-icons-generic-warning';
    case 'info':
      return 'ra-icons-generic-information-1';
    default:
      throw new Error(`Unable to implement alert with type: ${type}`);
  }
};

const alert = (props: AlertProps) => {
  const { type, message, title } = props;

  return (
    <div className={getClasses(type)}>
      <span className="flex items-center justify-center">
        <i className={`${getIcons(type)} pl-3 pr-3`} />
        <div className="flex-col">
          {title ? <div className="font-bold pb-0.5">{title}</div> : <></>}
          {message}
        </div>
      </span>
    </div>
  );
};

export default alert;
